import React from "react";
import GymNavigation from "../GymNavigation";
import Edit from "./Edit";
import View from "./View";
import Box from "components/UI/Box";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const Facilities = props => {
  const {
    email,
    address,
    phone,
    hours,
    workinghours,
    rate,
    gymid,
    gym,
    updateGym,
    time_note
  } = props;
  return (
    <React.Fragment>
      <GymNavigation />
      <div style={style.wrapper}>
        <Box outline style={style.box}>
          <Router>
            <Switch>
              <Route
                exact
                path="/gyms/gym/facilities/edit"
                render={props => (
                  <Edit
                    {...props}
                    gym={gym}
                    address={address}
                    email={email}
                    phone={phone}
                    hours={hours}
                    workinghours={workinghours}
                    rate={rate}
                    gymid={gymid}
                    updateGym={updateGym}
                    time_note={time_note}
                  />
                )}
              />
              <Route
                path=""
                render={props => (
                  <View
                    {...props}
                    address={address}
                    email={email}
                    phone={phone}
                    hours={hours}
                    workinghours={workinghours}
                    rate={rate}
                    gymid={gymid}
                    gym={gym}
                    time_note={time_note}
                  />
                )}
              />
            </Switch>
          </Router>
        </Box>
      </div>
    </React.Fragment>
  );
};

export default Facilities;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "1200px",
    marginBottom: "100px"
  }
};
